module.exports = __webpack_public_path__ + "img/DSC_2741-xl.e4b84834.png";